import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Photogallery from '../../containers/photogallery';
import PhotogalleryItem from '../../blocks/photogallery-item';
import PhotogalleryLayout from '../../containers/photogallery-layout';

const PhotogalleryBlock = props => <Photogallery {...props} />;
PhotogalleryBlock.displayName = 'Photogallery';

export default withDynamicComponents({
  componentWhitelist: [
    PhotogalleryItem,
    PhotogalleryLayout,
  ],
  mapInputToOutput: [
    ['photogalleryItem', 'photogalleryItem'],
    ['photogalleryLayout', 'photogalleryLayout'],
  ],
})(PhotogalleryBlock);



// WEBPACK FOOTER //
// ./src/blocks/photogallery/index.jsx